import LegalPageTemplate from "@/components/LegalPageTemplate";
import LegalDocument from "@/components/LegalDocument";
import { useLocale } from "@/lib/locale";

export default function TermsPage() {
    const { t } = useLocale();
    return (
        <LegalPageTemplate
            docType="terms"
            title={t("legal.terms_title")}
            eyebrow={t("legal.terms_eyebrow")}
            version="2026-02-v1"
        >
            <LegalDocument docKey="terms" />
        </LegalPageTemplate>
    );
}
